import { executeRequest, Request } from '@jfs/network'
import { AESEncryption, getRandomAlphaNumString, RSAEncryption } from '@jfs/utils'
import { getNetworkResponseError, isStatusOK, isStatusSuccess } from '../../utils'
import { getAPIURL, getJioFinHubHeader } from '../config'

export const MODE = 35
export const COUNTRY_CODE = '91'
export const SCOPE = 'REQUEST'
export const GENERATE = 'generate'
export const PURPOSE = 2
export const ENTITY_TYPE = 4
export const extraInfo = '20000033535'

export const getOtpRequestBody = (phoneNumber: string) => {
  return {
    user: {
      mobile: {
        mobileNumber: phoneNumber,
        countryCode: COUNTRY_CODE,
      },
      entityType: ENTITY_TYPE,
    },
    scope: SCOPE,
    authenticateList: [
      {
        mode: MODE,
        value: '',
        action: GENERATE,
      },
    ],
    purpose: PURPOSE,
  }
}

export const validateCustomerOtpBody = (mobileNumber: string, otp: string) => {
  const { REACT_APP_PUBLIC_ENC_KEY } = process.env
  const PUBLIC_ENC_KEY: any = REACT_APP_PUBLIC_ENC_KEY
  console.log('PUBLIC_ENC_KEY', REACT_APP_PUBLIC_ENC_KEY)
  let randomEncryptionKey = getRandomAlphaNumString(32)
  const encryptionKey = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY)
  let encOtp = AESEncryption(randomEncryptionKey, otp)
  return {
    user: {
      mobile: {
        mobileNumber,
        countryCode: '91',
      },
      entityType: ENTITY_TYPE,
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: 35,
        value: encOtp,
        action: 'verify',
      },
    ],
    secure: {
      encryptionKey,
    },
    purpose: PURPOSE,
  }
}

const responseParser = (data: any) => {
  console.log('data', data)
  if (isStatusOK(data) && isStatusSuccess(data?.data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const userAuthApi = (body: any) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('userAuthenticate')}`,
    method: 'POST',
    headers: getJioFinHubHeader(),
    body,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { userAuthApi }
